export enum ServiceZorgmailType {
    Geen = 'Geen',
    MEDLAB = 'MEDLAB',
    MEDSPE = 'MEDSPE',
    MEDVRI = 'MEDVRI',
}
